<p>Welcom {{currentUserInfo?.userName}} -- Schoolboard Policies User Management Tools</p>
<p>Add New User:</p>
<form id="userAddForm" method="post">
    <ng2-smart-table [settings]="settingsAdd" [source]="" (createConfirm)="onCreateConfirm($event)"></ng2-smart-table>
</form>

<hr>
<div>Select a user type:
    <select name="selectedUserType" ng-model="selectedUserType">
        <option>Select a User Type</option>
        <option *ngFor="let userType of userTypes" value="{{userType}}">{{userType}}</option>
    </select>
</div>
<br>
<ng2-smart-table [settings]="settings" [source]="userList"></ng2-smart-table>
<!-- <gui-grid [columns]="userListColumns" [source]="userList">

</gui-grid> -->
